export enum CardDensity {
  default = 'default',
  compact = 'compact',
  wide = 'wide',
}

export interface CardProps {
  density?: CardDensity | keyof typeof CardDensity;
  children?: React.ReactNode;
  className?: string;
  backgroundColor?: string;
  id?: string;
}
